export function headerFunc() {
	/**
	 * ハンバーガーメニュー
	 */
	$('.js-hamburger').on('click', function() {
		$('.js-hamburger').toggleClass('js-hamburger--closed');
		$('.js-nav').toggleClass('js-nav--opened');
	});

	$('.js-nav a').on('click', function() {
		$('.js-hamburger').removeClass('js-hamburger--closed');
		$('.js-nav').removeClass('js-nav--opened');
	});
}